import { PlusOutlined } from '@ant-design/icons'
import { Button, Modal, Space, Tabs } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { useWatch } from 'antd/es/form/Form'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DeliverySubscriptionType } from '../../../../../types/deliverySubscription/DeliverySubscription'
import { useDeliverySubscriptionSave } from '../../../../../features/deliverySubscriptions/hooks/useDeliverySubscriptionSave'
import { useSubscriptionFormState } from '../../../../../features/deliverySubscriptions/hooks/useSubscriptionFormState'
import AccountorScorecardSubscriptionForm from '../../../../../features/deliverySubscriptions/forms/AccountorScorecardSubscriptionForm'
import { DeliverySubscriptionFormData } from '../../../../../features/deliverySubscriptions/types'
import DeliverySubscriptionTable from './components/DeliverySubscriptionTable'

const AccountorScorecardSubscriptions: React.FC = () => {
  const { t } = useTranslation()
  const [form] = useForm<DeliverySubscriptionFormData>()
  const { open, deliverySubscription, handleClose, openForEdit, openForCreate } = useSubscriptionFormState(form)
  const initiatorType = useWatch(['initiator', 'type'], form)

  const { handleSave, handleSaveAndSend, isSaving } = useDeliverySubscriptionSave({
    subscriptionType: DeliverySubscriptionType.ACCOUNTOR_SCORECARD,
    deliverySubscription,
    form,
    onSuccess: handleClose
  })

  const items = [
    {
      label: t('subscriptionsPage:automatic-sent'),
      key: 'automatic',
      children: (
        <DeliverySubscriptionTable
          subscriptionType={DeliverySubscriptionType.ACCOUNTOR_SCORECARD}
          toggleDeliverySubscription={openForEdit}
          type="auto"
        />
      )
    },
    {
      label: t('subscriptionsPage:manual-sent'),
      key: 'manual',
      children: (
        <DeliverySubscriptionTable
          subscriptionType={DeliverySubscriptionType.ACCOUNTOR_SCORECARD}
          toggleDeliverySubscription={openForEdit}
          type="manual"
        />
      )
    }
  ]

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <Button type="primary" onClick={openForCreate}>
          <PlusOutlined />
          {t('global:add-new')}
        </Button>
      </div>
      <Modal
        destroyOnHidden
        title={
          deliverySubscription ? t('subscriptionsPage:edit-subscription') : t('subscriptionsPage:add-subscription')
        }
        open={open}
        maskClosable={false}
        onCancel={handleClose}
        footer={
          <Space>
            <Button onClick={handleClose}>{t('global:cancel')}</Button>
            <Button type="primary" loading={isSaving} onClick={handleSave}>
              {deliverySubscription ? t('global:update') : t('global:save')}
            </Button>
            {(initiatorType === 'periodLock' || initiatorType === 'manual') && (
              <Button type="primary" loading={isSaving} onClick={handleSaveAndSend}>
                {deliverySubscription ? t('global:update-and-send') : t('global:save-and-send')}
              </Button>
            )}
          </Space>
        }
      >
        <AccountorScorecardSubscriptionForm form={form} deliverySubscription={deliverySubscription} />
      </Modal>
      <Tabs defaultActiveKey="1" items={items} />
    </>
  )
}

export default AccountorScorecardSubscriptions
